module.exports = __webpack_public_path__ + "static/tree-95fb8566e2d14a5c8116ec2d29f5dfdf.svg";